/**
 * Transforma um número para percentual.
 *
 * @param value Número como `number`
 * @returns Número sem zero à esquerda e com símbolo percentual
 */

export const formatPercentual = (value: number | undefined) => {
  if (value === undefined || isNaN(value)) {
    return '';
  }
  let valor = Number(value);
  return (
    valor
      .toFixed(4)
      .replace(/(\.\d{2}[1-9]*)0+$/, '$1')
      .replace('.', ',') + '%'
  );
};
